import mediaQuery from '@util/media-queries';
import Modernizr from 'modernizr';

const Footer = {
    init () {

        $( '#nav-lvl-footer' ).on( 'click', '.nav-group-footer > a', e => {
            console.warn( '[TODO] - implement collapse-group on footer nav' )
            if ( Modernizr.mq( mediaQuery.max['screenMedium'] ) ) {
                e.preventDefault();

                $( e.currentTarget ).parent().toggleClass( 'nav-group-footer--active' );
            }
        } )

    }
};

export default Footer;
